import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginRouteLogged } from './can-activates/loginguard.provider';

export const routes: Routes = [
  {
    path: 'public',
    loadChildren: () => import('./public/public.module')
      .then(m => m.PublicModule)
  },
  {
    path: 'portal',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule), canActivate: [LoginRouteLogged]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module')
      .then(m => m.AuthModule),
  },
  { path: '', redirectTo: 'public', pathMatch: 'full' },
  { path: '**', redirectTo: 'public' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
